export function SVG_GetDefs(svgElement) {
  return svgElement["defs"];
}
